export default {
  delete_success: 'La oferta se ha eliminado correctamente',
  delete_failed: 'La eliminación de la oferta falló',
  delete_confirm_title: '¿Seguro que desea eliminar esta oferta?',
  delete_last_day_confirm_title:
    'Si eliminas el último día restante, se eliminará esta oferta. ¿Seguro que quieres continuar?',
  confirm: 'Confirmar',
  cancel: 'Cancelar',
  qualifying_items: 'Artículos elegibles',
  free_items: 'Artículos gratuitos',
  all_day: 'Todo el día',
  starts_on: 'Comienza el {{date}}',
  ends_on: 'Termina el {{date}}',
  ends_when_deleted: 'Termina al eliminarse',
  off: '{{amount}} de descuento',
  min_spend_value: 'Gasto mínimo: {{amount}}',
};
